import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
/**
 * Provides an analytics context to supply attributes to events based on a URL
 */
export var LinkAnalyticsContext = function LinkAnalyticsContext(_ref) {
  var display = _ref.display,
    id = _ref.id,
    children = _ref.children,
    source = _ref.source;
  var displayCategory = display === 'url' ? 'link' : undefined;
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      source: source,
      attributes: {
        displayCategory: displayCategory,
        display: display,
        id: id
      }
    }
  }, children);
};